import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { EPageType } from 'shared/models';

export const $CurrentDiscoverKeyword = atom((get) => {
  const traffic = get($PageLevelTraffic);
  const { pageType } = traffic;

  if (pageType !== EPageType.discover) {
    Unreachable('page type is not discover');
  }

  return traffic.keyword;
});
